import React, { useState } from "react";
import { X, Copy, Check } from "lucide-react";

const CampaignDetailsModal = ({ campaign, onClose }) => {
  const [copiedField, setCopiedField] = useState(null);

  if (!campaign) {
    return null;
  }

  const longUrl = campaign.fullUrl || "";
  const shortUrl = campaign.shortUrl || "";
  const campaignName = campaign.name || "Campaign";

  const copyToClipboard = async (text, field) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };


  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose?.();
        }
      }}
    >
      <div
        className="bg-white w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col shadow-xl rounded-lg"
        style={{ fontFamily: "Raleway, sans-serif" }}
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <div>
            <h2 className="text-xl font-semibold text-[#1F2937]">Campaign Details</h2>
            <p className="text-sm text-[#475569] mt-1">
              Here are the URLs for &quot;{campaignName}&quot;:
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-[#475569] hover:text-[#475569] transition-colors"
          >
            <X size={22} />
          </button>
        </div>

        <div className="flex-1 overflow-auto px-6 py-6">
          <div className="flex items-center justify-center gap-4">
            {shortUrl && (
              <button
                onClick={() => copyToClipboard(shortUrl, "short")}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors border border-gray-300 bg-white hover:bg-gray-50"
                style={{ fontFamily: 'Raleway, sans-serif' }}
              >
                {copiedField === "short" ? (
                  <>
                    <Check size={16} className="text-green-600" />
                    Short
                  </>
                ) : (
                  <>
                    <Copy size={16} style={{ color: '#666666' }} />
                    Short
                  </>
                )}
              </button>
            )}
            {longUrl && (
              <button
                onClick={() => copyToClipboard(longUrl, "long")}
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors border border-gray-300 bg-white hover:bg-gray-50"
                style={{ fontFamily: 'Raleway, sans-serif' }}
              >
                {copiedField === "long" ? (
                  <>
                    <Check size={16} className="text-green-600" />
                    Long
                  </>
                ) : (
                  <>
                    <Copy size={16} style={{ color: '#666666' }} />
                    Long
                  </>
                )}
              </button>
            )}
          </div>
        </div>

        <div className="border-t border-gray-200 px-6 py-4 flex items-center justify-end">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm rounded-lg transition-colors border border-gray-300 bg-[#4b57aa] text-white hover:bg-[#3d4799]"
            style={{ fontFamily: 'Raleway, sans-serif' }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CampaignDetailsModal;


